/** @jsx jsx */
import { css, jsx, keyframes } from '@emotion/react';

import * as React from 'react';

import { SpinnerIcon } from '@coursera/cds-icons';

type Props = {
  size?: 'small' | 'medium' | 'large';
  color?: 'default' | 'error' | 'invert' | 'success' | 'support' | 'interactive' | 'warning';
  className?: string;
};

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const styles = {
  animated: () => css`
    animation: ${rotate} 2s infinite linear;
  `,
};

function LoadingIcon({ size, color, className }: Props): React.ReactElement {
  return <SpinnerIcon size={size} color={color} className={className} css={styles.animated} />;
}

export default LoadingIcon;
